import { useMutation } from "react-query";
import { reactQueryDelete } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";

interface DeleteAttachmentOptions {
  onError?: (error: unknown) => void;
  onSuccess?: () => void;
}

interface DeleteAttachmentParams {
  attachmentId: string;
  conversationId: string;
}

export const useDeleteAttachment = ({
  onSuccess,
  onError,
}: DeleteAttachmentOptions = {}) =>
  useMutation({
    mutationFn: async ({
      conversationId,
      attachmentId,
    }: DeleteAttachmentParams) =>
      reactQueryDelete(
        internalApi.helpWidget.deleteAttachment({
          conversationId,
          attachmentId,
        }),
      ),
    onSuccess,
    onError,
  });
